import React from 'react';

const CreditCardOwnerFilterIcon = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M16 5H4.00002C3.26364 5 2.66669 5.59695 2.66669 6.33333V14.3333C2.66669 15.0697 3.26364 15.6667 4.00002 15.6667H16C16.7364 15.6667 17.3334 15.0697 17.3334 14.3333V6.33333C17.3334 5.59695 16.7364 5 16 5Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M2.66669 9H17.3334" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default CreditCardOwnerFilterIcon;
